import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "organization-company-view" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-wrap text-truncate" }, [
  /*#__PURE__*/_createTextVNode("My Organization"),
  /*#__PURE__*/_createElementVNode("span", null, " » Company")
], -1)
const _hoisted_4 = { class: "d-flex flex-column flex-sm-row text-end" }
const _hoisted_5 = { class: "me-sm-2 mb-2 mb-sm-0" }
const _hoisted_6 = { class: "dt-container" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "The organization name provides additional branding opportunities and helps clarify which receiver a user is connecting to.", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Sync usage reports from Ditto to your Splunk Cloud or Splunk Enterprise instance.", -1)
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Provide contact information for your organization's technical support. This information is displayed to a user if they are experiencing issues or request help.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            type: "info",
            onClick: _ctx.onCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode("Undo Changes")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            disabled: _ctx.saving,
            type: "primary",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode("Save Company")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_form, {
        ref: "form",
        rules: _ctx.rules,
        "label-position": "top",
        model: _ctx.company,
        "label-width": "120px",
        "hide-required-asterisk": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_form_item, {
                prop: "name",
                label: "Organization Name"
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.company.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.company.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Splunk Integration" }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _createVNode(_component_el_form_item, { label: "Token" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.company.splunk_token,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.company.splunk_token) = $event)),
                        placeholder: "HTTP Event Collector Token"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "URL" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.company.splunk_url,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.company.splunk_url) = $event)),
                        placeholder: "URL"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "Port" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.company.splunk_port,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.company.splunk_port) = $event)),
                        placeholder: "Port"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "Logger Name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.company.splunk_name,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.company.splunk_name) = $event)),
                        placeholder: "Logger Name"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_form_item, { label: "Organization Tech Support Information" }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _createVNode(_component_el_form_item, { label: "Details" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.company.helpDeskContact,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.company.helpDeskContact) = $event)),
                        placeholder: "Details"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "Phone Number" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.company.helpDeskPhone,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.company.helpDeskPhone) = $event)),
                        placeholder: "Phone Number"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "Help URL" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.company.helpDeskURL,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.company.helpDeskURL) = $event)),
                        placeholder: "Help URL"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "Email" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.company.helpDeskEmail,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.company.helpDeskEmail) = $event)),
                        placeholder: "Email"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ])
  ])), [
    [_directive_loading, _ctx.viewLoading]
  ])
}